import React, { useEffect, useState } from 'react';
import {
  IonCol,
  IonIcon,
  IonRow,
  IonSelect,
  IonSelectOption,
} from '@ionic/react';
import { useHistory, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { AxiosResponse } from 'axios';
import { Carousel } from 'react-responsive-carousel';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';

import './CasinoNew.scss';
import API from '../../../api';
import { RootState } from '../../../models/RootState';
import { DcGameNew } from '../../../models/dc/DcGame';
import {
  getCurrencyTypeFromToken,
  setCasinoGame,
  updateCasinoGames,
} from '../../../store';
import CasinoView from '../../../constants/CasinoView';
import { Tabs, Tab, Typography, TextField } from '@material-ui/core';
import TabPanel from '../../../components/TabPanel/TabPanel';
import { CasinoGameDTO } from '../../../models/IndianCasinoState';
import AllIcon from '../../../assets/images/casino/icons/all.svg';
import BackarratIcon from '../../../assets/images/casino/icons/backarrat.svg';
import RouletteIcon from '../../../assets/images/casino/icons/roulette.svg';
import BlackJackIcon from '../../../assets/images/casino/icons/blackjack.svg';
import IndianCasinoIcon from '../../../assets/images/casino/icons/indian.svg';
import PokerIcon from '../../../assets/images/casino/icons/poker.svg';
import SlotIcon from '../../../assets/images/casino/icons/slot.svg';
import OtherIcon from '../../../assets/images/casino/icons/other.svg';
import { useSelector } from 'react-redux';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Autocomplete from '@material-ui/lab/Autocomplete';
import SVLS_API from '../../../svls-api';

type StoreProps = {
  loggedIn: boolean;
  loggedInUserStatus: any;
  updateCasinoGames: (casinoGames: CasinoGameDTO[]) => void;
  setCasinoGame: (cGame: CasinoGameDTO) => void;
  langData : any;
};
function useQuery() {
  return new URLSearchParams(useLocation().search);
}
const DcPageNew: React.FC<StoreProps> = (props) => {
  const location = useLocation();
  const [games, setGames] = useState<DcGameNew[]>([]);
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const [casinoTabValue, setCasinoTabValue] = useState<number>(0);
  const [casinoGameCatTabValue, setCasinoGameCatTabValue] = useState<number>(0);
  const provider = useQuery().get('filteredProvider');
  const subprovider = useQuery().get('subprovider');
  const [filteredProvider, setFilteredProvider] = useState<string>(provider? provider: subprovider);
  const [providerList, setProviderList] = useState<string[]>();
  const langData=useSelector((state:RootState)=> state.common.langData);
  const liveCasinoGamesMap = {
    blackJack: 'Live Blackjack',
    baccarat: 'Live Baccarat',
    roulette: 'Live Roulette',
    andarBahar: 'Live Popular', //
    // teenPatti: 'Teen Patti', //
    poker: 'Live Poker',
    other: 'Others',
  };
  
  const { loggedIn, updateCasinoGames, setCasinoGame, loggedInUserStatus } =
    props;

  const history = useHistory();
  let WebBanners = CasinoView.CASINO_WEB_BANNERS;

  const [infoDialog, setInfoDialog] = useState<boolean>(false);
  const [selectedEvolutionGame, setSelectedEvolutionGame] = useState({
    gameId: null,
    gameName: null,
    gameCode: null,
    provider: null,
    subProvider: null,
  });
  // const UN_CHANGED_PROVIDER = ['ezg_', 'pgp_', 'ont_', 'bgt_'];
  const popProviders = ['Evolution Gaming' , 'Evoplay Entertainment', 'Spribe', 'Fugaso' , 'Monk88' , 'OneTouch' , 'Caleta Gaming' , 'Playtech Live', 'Smartsoft Gaming' , 'Booming Games' , 'Big Time Gaming']

  const setDialogShow = (show: boolean) => {
    setShowDialog(show);
  };

  const getDcGames = async () => {
    let response: AxiosResponse<DcGameNew[]>;
    if (loggedIn) {
      response = await SVLS_API.get('/catalog/v2/categories/indian-casino/games/', {
        params: {
          providerId: '*',
        },
        headers: {
          Authorization: sessionStorage.getItem('jwt_token'),
        },
      });
    } else {
      response = await SVLS_API.get('/catalog/v2/categories/indian-casino/games/', {
        params: {
          providerId: '*',
        },
      });
    }
    setGames(response.data);
    setProviderList(
      response.data
        .map((g) => g.subProviderName)
        .filter(function (elem, index, self) {
          return index === self.indexOf(elem);
        })
    );
    setFilteredProvider(filteredProvider);
  };

  const getGameUrl = async (
    gameId: string,
    gameName: string,
    gameCode: string,
    provider: string,
    subProvider: string
  ) => {
    if (loggedIn) {
      // status check
      if (loggedInUserStatus === 0 || loggedInUserStatus === 3) {
        history.push(`/home`);
      }
      if (provider === 'Indian Casino') {
        setCasinoGame({ id: gameCode, name: gameName });
        history.push(`/casino/indian/${gameCode}`);
      } else {
        history.push(
          `/dc/gamev1.1/${gameName?.toLowerCase().replace(/\s+/g, '-')}-${btoa(
            gameId?.toString()
          )}-${btoa(gameCode)}-${btoa(provider)}-${btoa(subProvider)}`
        );
      }
    } else {
      setDialogShow(true);
    }
  };

  const handleGameClick = async (
    gameId: string,
    gameName: string,
    gameCode: string,
    subProvider: string,
    provider?: string
  ) => {
    if(getCurrencyTypeFromToken() === 0 &&
      popProviders.filter((item) => subProvider === item).length) {
      setSelectedEvolutionGame({
      gameId,
      gameName,
      gameCode,
      provider,
      subProvider,
    });
      setInfoDialog(true);
      return;
    }
    
    if (
      getCurrencyTypeFromToken() === 0 &&
      !(
        provider?.toLocaleLowerCase() === 'ezugi' ||
        subProvider === 'BetGames.TV' ||
        subProvider === 'Pragmatic Play' ||
        subProvider === 'Onetouch Live' ||
        subProvider === 'OneTouch' ||
        provider === 'RG'
      )
    ) {
      getGameUrl(gameId, gameName, gameCode, provider, subProvider);
      // setSelectedEvolutionGame({
      //   gameId,
      //   gameName,
      //   gameCode,
      //   provider,
      //   subProvider,
      // });
      // setInfoDialog(true);
    } else {
      getGameUrl(gameId, gameName, gameCode, provider, subProvider);
    }
  };

  const getIndianCasinoGameUrl = async () => {
    if (loggedIn) {
      history.push(`/indian_casino`);
    } else {
      setDialogShow(true);
    }
  };

  useEffect(() => {
    getDcGames();
  }, [loggedIn]);
  
  useEffect(() => {  
    if (providerList?.includes(filteredProvider)) 
      {       
        setFilteredProvider(filteredProvider);  
      } 
    else 
        {       
          setFilteredProvider(''); 
        } 
    }, [providerList, filteredProvider]);

  useEffect(() => {
    if (loggedIn && casinoTabValue === 1) {
      history.push(`/indian_casino/live`);
    }
  }, [casinoTabValue, loggedIn]);

  let blackjackList = games.filter(
    (g) => g.category === liveCasinoGamesMap.blackJack
  );

  let baccaratList = games.filter(
    (g) =>
      g.category.toLowerCase().includes('baccarat') ||
      g.gameName.toLowerCase().includes('baccarat')
  );

  let rouletteList = games.filter(
    (g) =>
      g.category.toLowerCase().includes('roulette') ||
      g.gameName.toLowerCase().includes('roulette')
  );

  let andarBahaarList = games.filter(
    (g) =>
      g.category === liveCasinoGamesMap.andarBahar || g.providerName === 'RG'
  );

  let pokerList = games.filter(
    (g) =>
      g.category.toLowerCase().includes('poker') ||
      g.gameName.toLowerCase().includes('poker')
  );

  let otherList = games.filter(
    (g) =>
      g.category === liveCasinoGamesMap.other ||
      ['Onetouch Live', 'Asia Gaming'].includes(g.subProviderName)
  );
  let slotGamesList = games.filter((g) => g.category === 'Video Slots');

  let betGamesList = games.filter(
    (g) => g.category.toLowerCase() === 'tv games'
  );

  const getMobileBanners = () => {
    return CasinoView.CASINO_MOBILE_BANNERS;
  };

  return (
    <div className="dc-page-bg">
      <Carousel
        className="casino-web-banners"
        autoPlay={true}
        infiniteLoop={true}
        interval={5000}
        showThumbs={false}
        showStatus={false}
      >
        {WebBanners.map((banner) => (
          <div key={banner.text + 'container'}>
            <img
              className="banner-images"
              src={banner.image}
              key={banner.text + 'image'}
              alt={'banner'}
            />
          </div>
        ))}
      </Carousel>
      <Carousel
        className="casino-mobile-banners"
        autoPlay={true}
        infiniteLoop={true}
        interval={5000}
        showThumbs={false}
        showStatus={false}
      >
        {getMobileBanners().map((banner) => (
          <div key={banner.text + 'container'}>
            <img
              className="banner-images"
              src={banner.image}
              key={banner.text + 'image'}
              alt={'banner'}
            />
          </div>
        ))}
      </Carousel>

      <div className="dc-ctn">
        <IonRow class="casino-filters-row">
          <IonCol>
            <Tabs
              value={casinoGameCatTabValue}
              onChange={(_, newValue) => {
                setCasinoGameCatTabValue(newValue);
              }}
              variant="scrollable"
              scrollButtons="auto"
              className="game-types-tabs"
            >
              <Tab
                label={langData?.['all']}
                value={0}
                icon={<IonIcon className="casino-icon" src={AllIcon} />}
              />
              <Tab
                label= {langData?.['indian']}
                value={1}
                icon={
                  <IonIcon className="casino-icon" src={IndianCasinoIcon} />
                }
              />
              <Tab
                label={langData?.['roulette']}
                value={2}
                icon={<IonIcon className="casino-icon" src={RouletteIcon} />}
              />
              <Tab
                label={langData?.['baccarat']}
                value={3}
                icon={<IonIcon className="casino-icon" src={BackarratIcon} />}
              />
              <Tab
                label={langData?.['blackjack']}
                value={4}
                icon={<IonIcon className="casino-icon" src={BlackJackIcon} />}
              />
              <Tab
                label={langData?.['poker']}
                value={5}
                icon={<IonIcon className="casino-icon" src={PokerIcon} />}
              />
              <Tab
                label={langData?.['slot']}
                value={6}
                icon={<IonIcon className="casino-icon" src={SlotIcon} />}
              />
              <Tab
                label={langData?.['other']}
                value={7}
                icon={<IonIcon className="casino-icon" src={OtherIcon} />}
              />
            </Tabs>
          </IonCol>
          <IonCol className="casino-filters-col">
            <Autocomplete
              freeSolo
              id="free-solo-2-demo"
              className="search-games-ctn"
              disableClearable
              options={games}
              getOptionLabel={(option) => option.gameName}
              onChange={(event, g) => {
                handleGameClick(
                  Object(g).gameId,
                  Object(g).gameName,
                  Object(g).gameCode,
                  Object(g).subProviderName,
                  Object(g).providerName
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={langData?.['select_games']}
                  margin="normal"
                  variant="outlined"
                  className="search-games-text"
                  InputProps={{ ...params.InputProps, type: 'search' }}
                />
              )}
            />
            <IonSelect
              className="select-filter"
              value={filteredProvider} 
              placeholder={langData?.['select_one']}
              interface="popover"
              onIonChange={(e) => setFilteredProvider(e.detail.value)}
            >
              <IonSelectOption key={'option--1'} value={''}>
              {providerList? langData?.['select_provider']:'Loading..'}
              </IonSelectOption>
              {providerList &&
                providerList.map((opt, idx) => (
                  <IonSelectOption key={'option-' + idx} value={opt}>
                    {opt}
                  </IonSelectOption>
                ))}
            </IonSelect>
          </IonCol>
        </IonRow>

        <TabPanel value={casinoGameCatTabValue} index={0}>
          {games && games.length > 0 ? (
            <>
              <div className="dc-games-ctn">
                {games
                  // .filter((g) =>
                  //   Object.values(liveCasinoGamesMap).includes(g.Type)
                  // )
                  .map((g, i) => (
                    <>
                      {filteredProvider &&
                      g.subProviderName != filteredProvider ? null : (
                        <Card
                          className="dc-ion-card"
                          onClick={() =>
                            handleGameClick(
                              g.gameId,
                              g.gameName,
                              g.gameCode,
                              g.subProviderName,
                              g.providerName
                            )
                          }
                        >
                          <CardActionArea>
                            <CardMedia
                              component="img"
                              alt={g.gameName}
                              className="dc-card-media"
                              image={g.urlThumb ? g.urlThumb : ''}
                              title={g.gameName}
                            />
                            <CardContent className="dc-card-ctn">
                              <Typography gutterBottom className="game-name">
                                {g.gameName}
                              </Typography>
                              {loggedIn && g.minLimits && g.maxLimits ? (
                                <Typography
                                  variant="caption"
                                  className="game-range"
                                >
                                  {g.minLimits} - {g.maxLimits}
                                </Typography>
                              ) : null}
                            </CardContent>
                          </CardActionArea>
                        </Card>
                      )}
                    </>
                  ))}
              </div>
            </>
          ) : null}
          {/* {indianCasinoGamesList.map((ig, idx) => (
            <Card
              key={'incasino-game-' + idx}
              className="dc-ion-card"
              onClick={() =>
                handleGameClick(766, ig.name, ig.id, 'Indian Casino')
              }
            >
              <CardActionArea>
                <CardMedia
                  component="img"
                  alt={ig.name}
                  className="dc-card-media"
                  image={ig.image ? ig.image : ''}
                  title={ig.name}
                />
                <CardContent className="dc-card-ctn">
                  <Typography gutterBottom className="game-name">
                    {ig.name}
                  </Typography>
                  <Typography variant="caption" className="game-range">
                    {ig.id}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          ))} */}
        </TabPanel>

        <TabPanel value={casinoGameCatTabValue} index={1}>
          <div className="dc-games-ctn">
            {andarBahaarList && andarBahaarList.length > 0 ? (
              <>
                {andarBahaarList.map((g, i) => (
                  <Card
                    key={i}
                    className="dc-ion-card"
                    onClick={() =>
                      handleGameClick(
                        g.gameId,
                        g.gameName,
                        g.gameCode,
                        g.subProviderName,
                        g.providerName
                      )
                    }
                  >
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        alt={g.gameName}
                        className="dc-card-media"
                        image={g.urlThumb ? g.urlThumb : ''}
                        title={g.gameName}
                      />
                      <CardContent className="dc-card-ctn">
                        <Typography gutterBottom className="game-name">
                          {g.gameName}
                        </Typography>
                        {loggedIn && g.minLimits && g.maxLimits ? (
                          <Typography variant="caption" className="game-range">
                            {g.minLimits} - {g.maxLimits}
                          </Typography>
                        ) : null}
                      </CardContent>
                    </CardActionArea>
                  </Card>
                ))}
              </>
            ) : null}
            {/* {teenpattiList && teenpattiList.length > 0 ? (
              <>
                {teenpattiList.map((g, i) => (
                  <Card
                    className="dc-ion-card"
                    onClick={() =>
                      handleGameClick(
                        g.gameId,
                        g.gameName,
                        g.gameCode,
                        g.subProviderName,
                        g.providerName
                      )
                    }
                  >
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        alt={g.gameName}
                        className="dc-card-media"
                        image={g.urlThumb ? g.urlThumb : ''}
                        title={g.gameName}
                      />
                      <CardContent className="dc-card-ctn">
                        <Typography gutterBottom className="game-name">
                          {g.gameName}
                        </Typography>
                        {loggedIn && g.minLimits && g.maxLimits ? (
                          <Typography variant="caption" className="game-range">
                            {g.minLimits} - {g.maxLimits}
                          </Typography>
                        ) : null}
                      </CardContent>
                    </CardActionArea>
                  </Card>
                ))}
              </>
            ) : null} */}
            {/* {indianCasinoGamesList.map((ig, idx) => (
              <Card
                key={'incasino-game-' + idx}
                className="dc-ion-card"
                onClick={() =>
                  handleGameClick(766, ig.name, ig.id, 'Indian Casino')
                }
              >
                <CardActionArea>
                  <CardMedia
                    component="img"
                    alt={ig.name}
                    className="dc-card-media"
                    image={ig.image ? ig.image : ''}
                    title={ig.name}
                  />
                  <CardContent className="dc-card-ctn">
                    <Typography gutterBottom className="game-name">
                      {ig.name}
                    </Typography>
                    <Typography variant="caption" className="game-range">
                      {ig.id}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            ))} */}
          </div>
        </TabPanel>

        <TabPanel value={casinoGameCatTabValue} index={2}>
          {rouletteList && rouletteList.length > 0 ? (
            <>
              {/* <h1>Roulette</h1> */}
              <div className="dc-games-ctn">
                {rouletteList.map((g, i) => (
                  <>
                    {filteredProvider &&
                    g.subProviderName != filteredProvider ? null : (
                      <Card
                        className="dc-ion-card"
                        key={i}
                        onClick={() =>
                          handleGameClick(
                            g.gameId,
                            g.gameName,
                            g.gameCode,
                            g.subProviderName,
                            g.providerName
                          )
                        }
                      >
                        <CardActionArea>
                          <CardMedia
                            component="img"
                            alt={g.gameName}
                            className="dc-card-media"
                            image={g.urlThumb ? g.urlThumb : ''}
                            title={g.gameName}
                          />
                          <CardContent className="dc-card-ctn">
                            <Typography gutterBottom className="game-name">
                              {g.gameName}
                            </Typography>
                            {loggedIn && g.minLimits && g.maxLimits ? (
                              <Typography
                                variant="caption"
                                className="game-range"
                              >
                                {g.minLimits} - {g.maxLimits}
                              </Typography>
                            ) : null}
                          </CardContent>
                        </CardActionArea>
                      </Card>
                    )}
                  </>
                ))}
              </div>
            </>
          ) : null}
        </TabPanel>

        <TabPanel value={casinoGameCatTabValue} index={3}>
          {baccaratList && baccaratList.length > 0 ? (
            <>
              {/* <h1>Baccarat</h1> */}
              <div className="dc-games-ctn">
                {baccaratList.map((g, i) => (
                  <>
                    {filteredProvider &&
                    g.subProviderName != filteredProvider ? null : (
                      <Card
                        className="dc-ion-card"
                        key={i}
                        onClick={() =>
                          handleGameClick(
                            g.gameId,
                            g.gameName,
                            g.gameCode,
                            g.subProviderName,
                            g.providerName
                          )
                        }
                      >
                        <CardActionArea>
                          <CardMedia
                            component="img"
                            alt={g.gameName}
                            className="dc-card-media"
                            image={g.urlThumb ? g.urlThumb : ''}
                            title={g.gameName}
                          />
                          <CardContent className="dc-card-ctn">
                            <Typography gutterBottom className="game-name">
                              {g.gameName}
                            </Typography>
                            {loggedIn && g.minLimits && g.maxLimits ? (
                              <Typography
                                variant="caption"
                                className="game-range"
                              >
                                {g.minLimits} - {g.maxLimits}
                              </Typography>
                            ) : null}
                          </CardContent>
                        </CardActionArea>
                      </Card>
                    )}
                  </>
                ))}
              </div>
            </>
          ) : null}
        </TabPanel>

        <TabPanel value={casinoGameCatTabValue} index={4}>
          {blackjackList && blackjackList.length > 0 ? (
            <>
              {/* <h1>Blackjack</h1> */}
              <div className="dc-games-ctn">
                {blackjackList.map((g, i) => (
                  <>
                    {filteredProvider &&
                    g.subProviderName != filteredProvider ? null : (
                      <Card
                        className="dc-ion-card"
                        key={i}
                        onClick={() =>
                          handleGameClick(
                            g.gameId,
                            g.gameName,
                            g.gameCode,
                            g.subProviderName,
                            g.providerName
                          )
                        }
                      >
                        <CardActionArea>
                          <CardMedia
                            component="img"
                            alt={g.gameName}
                            className="dc-card-media"
                            image={g.urlThumb ? g.urlThumb : ''}
                            title={g.gameName}
                          />
                          <CardContent className="dc-card-ctn">
                            <Typography gutterBottom className="game-name">
                              {g.gameName}
                            </Typography>
                            {loggedIn && g.minLimits && g.maxLimits ? (
                              <Typography
                                variant="caption"
                                className="game-range"
                              >
                                {g.minLimits} - {g.maxLimits}
                              </Typography>
                            ) : null}
                          </CardContent>
                        </CardActionArea>
                      </Card>
                    )}
                  </>
                ))}
              </div>
            </>
          ) : null}
          {/* {indianCasinoGamesList.map((ig, idx) => (
            <Card
              key={'incasino-game-' + idx}
              className="dc-ion-card"
              onClick={() => getGameUrl(766, ig.name, ig.id, 'Indian Casino')}
            >
              <CardActionArea>
                <CardMedia
                  component="img"
                  alt={ig.name}
                  className="dc-card-media"
                  image={ig.image ? ig.image : ''}
                  title={ig.name}
                />
                <CardContent className="dc-card-ctn">
                  <Typography gutterBottom className="game-name">
                    {ig.name}
                  </Typography>
                  <Typography variant="caption" className="game-range">
                    {ig.id}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          ))} */}
        </TabPanel>

        <TabPanel value={casinoGameCatTabValue} index={5}>
          {pokerList && pokerList.length > 0 ? (
            <>
              {/* <h1>Poker</h1> */}
              <div className="dc-games-ctn">
                {pokerList.map((g, i) => (
                  <>
                    {filteredProvider &&
                    g.subProviderName != filteredProvider ? null : (
                      <Card
                        className="dc-ion-card"
                        key={i}
                        onClick={() =>
                          handleGameClick(
                            g.gameId,
                            g.gameName,
                            g.gameCode,
                            g.subProviderName,
                            g.providerName
                          )
                        }
                      >
                        <CardActionArea>
                          <CardMedia
                            component="img"
                            alt={g.gameName}
                            className="dc-card-media"
                            image={g.urlThumb ? g.urlThumb : ''}
                            title={g.gameName}
                          />
                          <CardContent className="dc-card-ctn">
                            <Typography gutterBottom className="game-name">
                              {g.gameName}
                            </Typography>
                            {loggedIn && g.minLimits && g.maxLimits ? (
                              <Typography
                                variant="caption"
                                className="game-range"
                              >
                                {g.minLimits} - {g.maxLimits}
                              </Typography>
                            ) : null}
                          </CardContent>
                        </CardActionArea>
                      </Card>
                    )}
                  </>
                ))}
              </div>
            </>
          ) : null}
        </TabPanel>

        <TabPanel value={casinoGameCatTabValue} index={6}>
          {slotGamesList && slotGamesList.length > 0 ? (
            <>
              <div className="dc-games-ctn slot-games">
                {slotGamesList.map((g, i) => (
                  <>
                    {filteredProvider &&
                    g.subProviderName != filteredProvider ? null : (
                      <Card
                        className="dc-ion-card"
                        key={i}
                        onClick={() =>
                          handleGameClick(
                            g.gameId,
                            g.gameName,
                            g.gameCode,
                            g.subProviderName,
                            g.providerName
                          )
                        }
                      >
                        <CardActionArea>
                          <CardMedia
                            component="img"
                            alt={g.gameName}
                            className="dc-card-media"
                            image={g.urlThumb ? g.urlThumb : ''}
                            title={g.gameName}
                          />
                          <CardContent className="dc-card-ctn">
                            <Typography gutterBottom className="game-name">
                              {g.gameName}
                            </Typography>
                            {loggedIn && g.minLimits && g.maxLimits ? (
                              <Typography
                                variant="caption"
                                className="game-range"
                              >
                                {g.minLimits} - {g.maxLimits}
                              </Typography>
                            ) : null}
                          </CardContent>
                        </CardActionArea>
                      </Card>
                    )}
                  </>
                ))}
              </div>
            </>
          ) : null}
        </TabPanel>

        <TabPanel value={casinoGameCatTabValue} index={7}>
          {otherList && otherList.length > 0 ? (
            <>
              {/* <h1>Other</h1> */}
              <div className="dc-games-ctn">
                {otherList.map((g, i) => (
                  <>
                    {filteredProvider &&
                    g.subProviderName != filteredProvider ? null : (
                      <Card
                        className="dc-ion-card"
                        key={i}
                        onClick={() =>
                          handleGameClick(
                            g.gameId,
                            g.gameName,
                            g.gameCode,
                            g.subProviderName,
                            g.providerName
                          )
                        }
                      >
                        <CardActionArea>
                          <CardMedia
                            component="img"
                            alt={g.gameName}
                            className="dc-card-media"
                            image={g.urlThumb ? g.urlThumb : ''}
                            title={g.gameName}
                          />
                          <CardContent className="dc-card-ctn">
                            <Typography gutterBottom className="game-name">
                              {g.gameName}
                            </Typography>
                            {loggedIn && g.minLimits && g.maxLimits ? (
                              <Typography
                                variant="caption"
                                className="game-range"
                              >
                                {g.minLimits} - {g.maxLimits}
                              </Typography>
                            ) : null}
                          </CardContent>
                        </CardActionArea>
                      </Card>
                    )}
                  </>
                ))}
              </div>
            </>
          ) : null}
        </TabPanel>
      </div>

      <Dialog
        open={showDialog}
        onClose={() => setDialogShow(false)}
        aria-labelledby="form-dialog-title"
        maxWidth="xs"
      >
        <DialogTitle id="form-dialog-title">Notice</DialogTitle>
        <DialogContent>
          <div className="dc-dialog-body">You have to be logged in to play</div>
        </DialogContent>
        <DialogActions className="dc-dialog-actions">
          <Button
            onClick={() => setDialogShow(false)}
            color="primary"
            autoFocus
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={infoDialog}
        onClose={() => {
          setInfoDialog(false);
          setSelectedEvolutionGame(null);
        }}
        aria-labelledby="form-dialog-title"
        className="dialog-div"
      >
        <div className="dialog-div-body">
          <div className="dialog-title">Game Info</div>
          <div className="dialog-body">
            1 Casino Point is equal to 10 Normal Points.
            <div className="dialog-ex">
              {' '}
              Ex: 100 Casino Points = 1000 Points
            </div>
          </div>
          <div className="dialog-continue">
            <div
              className="custom-btn btn"
              onClick={() =>
                getGameUrl(
                  selectedEvolutionGame?.gameId,
                  selectedEvolutionGame?.gameName,
                  selectedEvolutionGame?.gameCode,
                  selectedEvolutionGame?.provider,
                  selectedEvolutionGame?.subProvider
                )
              }
            >
              Continue
            </div>

            <div
              className="custom-btn-close"
              onClick={() => {
                setInfoDialog(false);
                setSelectedEvolutionGame(null);
              }}
            >
              Close
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  let status = 0;
  if (state.auth.loggedIn) {
    status = JSON.parse(
      window.atob(sessionStorage.getItem('jwt_token').split('.')[1])
    ).status;
  }
  return {
    loggedIn: state.auth.loggedIn,
    loggedInUserStatus: status,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    updateCasinoGames: (casinoGames: CasinoGameDTO[]) =>
      dispatch(updateCasinoGames(casinoGames)),
    setCasinoGame: (cGame: CasinoGameDTO) => dispatch(setCasinoGame(cGame)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DcPageNew);
